export function data_obj_to_attrs(data: object | undefined) {
  return data
    ? Object.entries(data).reduce<Record<string, string>>((obj, [k, v]) => {
        obj[`data-${k}`] = v
        return obj
      }, {})
    : {}
}

export function toggle_checkbox(
  el: HTMLInputElement,
  force?: boolean
): boolean {
  el.indeterminate = false
  el.checked = typeof force === 'boolean' ? force : !el.checked

  const event = new Event('change')
  el.dispatchEvent(event)

  return el.checked
}

// build a URL query object from an object
// https://stackoverflow.com/a/69904130/349604
// Usage: call toString() on this to return a query string
export function buildParams(data?: object, parent_param = '') {
  const params = new URLSearchParams()

  if (!data) return params

  const key_str = (key: string) =>
    parent_param ? `${parent_param}[${key}]` : key

  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((value) => {
        params.append(`${key_str(key)}[]`, value.toString())
      })
    } else if (value) {
      params.append(key_str(key), value.toString())
    }
  })

  // sort for consistency
  params.sort()

  return params
}
